import GridListComponent from "./grid-list";

function GridList({ columns, items, itemComponent, className }) {
  return (
    <GridListComponent
      columns={columns}
      items={items}
      itemComponent={itemComponent}
      className={className}
    />
  );
}

export default GridList;
